export type CountryType = 'DE' | 'HU' | 'TR' | 'UA'
export const availableCountries: CountryType[] = ['DE', 'HU', 'TR', 'UA']
